"use client";

import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { type GetVersionsRequest } from "@/generated/fastapi";
import { getVersions } from "../api/getVersions";
import { versioningKeys } from "./keys";

export default function useVersionsQuery(request: GetVersionsRequest = {}) {
  const { accessToken } = useAuth();

  return useQuery({
    queryKey: versioningKeys.list(request),
    queryFn: () => getVersions(accessToken, request),
    enabled: Boolean(accessToken),
  });
}
